// Feat planner images (sprites from the joharaoc.eu planner): per class a tree background (all three trees side by
// side, 998x579) and an icon sprite (38px icons, greyed top row, coloured bottom row), one icon sprite per archetype
// for the general tree, and the border, rank pip and prerequisite arrow sprites.
import bgbarb from 'assets/feats/bgbarb.jpg';
import bgbs from 'assets/feats/bgbs.jpg';
import bgconq from 'assets/feats/bgconq.jpg';
import bgdemo from 'assets/feats/bgdemo.jpg';
import bgdt from 'assets/feats/bgdt.jpg';
import bgguard from 'assets/feats/bgguard.jpg';
import bghox from 'assets/feats/bghox.jpg';
import bgnecro from 'assets/feats/bgnecro.jpg';
import bgpom from 'assets/feats/bgpom.jpg';
import bgranger from 'assets/feats/bgranger.jpg';
import bgsin from 'assets/feats/bgsin.jpg';
import bgtos from 'assets/feats/bgtos.jpg';
import iconbarb from 'assets/feats/iconbarb.png';
import iconbs from 'assets/feats/iconbs.png';
import iconconq from 'assets/feats/iconconq.png';
import icondemo from 'assets/feats/icondemo.png';
import icondt from 'assets/feats/icondt.png';
import iconguard from 'assets/feats/iconguard.png';
import iconhox from 'assets/feats/iconhox.png';
import iconnecro from 'assets/feats/iconnecro.png';
import iconpom from 'assets/feats/iconpom.png';
import iconranger from 'assets/feats/iconranger.png';
import iconsin from 'assets/feats/iconsin.png';
import icontos from 'assets/feats/icontos.png';
import icongmage from 'assets/feats/icongmage.png';
import icongpriest from 'assets/feats/icongpriest.png';
import icongrogue from 'assets/feats/icongrogue.png';
import icongsoldier from 'assets/feats/icongsoldier.png';
import border from 'assets/feats/border.png';
import point from 'assets/feats/point.png';
import req from 'assets/feats/req.png';

const BACKGROUNDS: Record<string, string> = {
  barb: bgbarb, bs: bgbs, conq: bgconq, demo: bgdemo, dt: bgdt, guard: bgguard, hox: bghox, necro: bgnecro, pom: bgpom, ranger: bgranger, sin: bgsin, tos: bgtos,
};
const ICONS: Record<string, string> = {
  barb: iconbarb, bs: iconbs, conq: iconconq, demo: icondemo, dt: icondt, guard: iconguard, hox: iconhox, necro: iconnecro, pom: iconpom, ranger: iconranger,
  sin: iconsin, tos: icontos, gmage: icongmage, gpriest: icongpriest, grogue: icongrogue, gsoldier: icongsoldier,
};

export const featAssets = {
  background: (sprite: string) => BACKGROUNDS[sprite],
  icons: (sprite: string) => ICONS[sprite],
  border,
  point,
  req,
};
